import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import Capabilities from "@/components/sections/Capabilities";
import TrustedLogos from "@/components/sections/TrustedLogos";
import AnalyzerFeature from "@/components/sections/AnalyzerFeature";
import CaseStudies from "@/components/sections/CaseStudies";
import Process from "@/components/sections/Process";
import Industries from "@/components/sections/Industries";
import Pricing from "@/components/sections/Pricing";
import Founder from "@/components/sections/Founder";
import FinalCTA from "@/components/sections/FinalCTA";
import GalleryTeaser from "@/components/sections/GalleryTeaser";
import RevenueCenterTeaser from "@/components/sections/RevenueCenterTeaser";
import { WhatsNewTeaser } from "@/components/sections/WhatsNewTeaser";
import AnalyzerResults from "@/components/AnalyzerResults";
import { HubCapabilityStrip } from "@/pages/ConversationHubLanding";
import GrowthSystemHero from "@/components/sections/GrowthSystemHero";
import { AnalyzerProvider, useAnalyzer } from "@/context/AnalyzerContext";
import usePageSeo from "@/hooks/usePageSeo";
import { PAGE_SEO } from "@/data/pageSeo";

function HomeContent() {
  const { openConsult } = useAnalyzer();
  return (
    <main>
      <Hero />
      <GrowthSystemHero />
      <AnalyzerResults />
      <TrustedLogos />
      <Capabilities />
      <HubCapabilityStrip />
      <AnalyzerFeature />
      <RevenueCenterTeaser />
      <CaseStudies />
      <GalleryTeaser />
      <WhatsNewTeaser />
      <Process />
      <Industries />
      <Pricing onBook={openConsult} />
      <Founder onBook={openConsult} />
      <FinalCTA onBook={openConsult} />
    </main>
  );
}

export default function Home() {
  usePageSeo(PAGE_SEO["/"]);
  return (
    <>
      <Navbar />
      <AnalyzerProvider>
        <HomeContent />
      </AnalyzerProvider>
      <Footer />
    </>
  );
}
